import React from "react";
import { Button } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPrint, faSave } from "@fortawesome/free-solid-svg-icons";

export default function SearchControls({
  totalFiltered,
  selectedCount,
  onExport,
  onClear,
  onPrint,
}) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        padding: "0 16px",
      }}
    >
      <h5 className="text-indigo-500"> عدد الفواتير المحدده {selectedCount}</h5>
      <Button onClick={onExport}>
        <FontAwesomeIcon icon={faSave} /> تصدير إلى Excel
      </Button>
      <button
        className="px-4 my-3 py-2 bg-red-500 text-white font-semibold rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50"
        onClick={onClear}
      >
        مسح
      </button>
      <Button onClick={onPrint}>
        <FontAwesomeIcon icon={faPrint} /> طباعة
      </Button>
    </div>
  );
} 
